import React from 'react';
import { Row, Col } from '../grid';
import DayPicker from '../DayPicker';
import { Span } from '../typography';
import ClickableDiv from '../ClickableDiv';
import { ScreenSizeDetector } from '../../lib/helpers';


export default class DateElement extends React.Component {
  constructor(props) {
    super(props);
    this.dayPickerRef = React.createRef();
  }

  render() {
    const {
      date,
      onDateChange,
      getDayText,
      timeComponent,
      children,
      minDate,
      disabled,
      disabledDays,
      disabledWeekDays,
      error,
      isHidden,
      dateType,
      deliveryType,
      isSmall,
      ...rest
    } = this.props;
    if (isHidden) {
      return null;
    }
    // Cheatsheat https://devhints.io/moment
    const formatBreaks = isSmall
      ? [[767, 'dddd, D. MMMM YYYY'], [991, 'ddd, D. MMMM YYYY'], [1199, 'ddd, D. MMM. YY'], 'ddd, D. MMMM YYYY']
      : [[767, 'dddd, D. MMMM YYYY'], [1199, 'ddd, D. MMMM YYYY'], 'dddd, D. MMMM YYYY'];
    return (
      <Row {...rest}>
        <Col xs={12} padding="0 15px 0 15px" relative>
          <ClickableDiv
            onClick={() => this.dayPickerRef.current.showDayPicker()}
            clickable={!disabled}
            onOutsideClick={() => {
              const {
                dayPickerRef: {
                  current,
                },
              } = this;
              if (current) {
                current.hideDayPicker();
              }
            }}
            className={`datePicker_${dateType}_${deliveryType}`}
          >
            <ScreenSizeDetector dateFormat={formatBreaks}>
              <DayPicker
                placeholder="Vælg dato"
                disabled={disabled}
                minDate={minDate}
                disabledDays={disabledDays}
                disabledWeekDays={disabledWeekDays}
                day={date}
                getDayText={getDayText}
                onDayChange={onDateChange}
                customRef={this.dayPickerRef}
                error={error}
                data-recording-gdpr-safe
              />
            </ScreenSizeDetector>
            <ScreenSizeDetector top={[[767, '2px'], [991, '11px'], '9px']}>
              <Span absolute block left="26px" bold>{children}</Span>
            </ScreenSizeDetector>
          </ClickableDiv>
        </Col>
        {timeComponent && (
          <Col xs={12} padding="10px 15px 0 15px">
            {timeComponent}
          </Col>
        )}
      </Row>
    );
  }
}
